
interface ProcessStep {
  title: string;
  description: string;
}

interface ServiceProcessProps {
  steps: ProcessStep[];
}

export const ServiceProcess = ({ steps }: ServiceProcessProps) => {
  return (
    <div className="py-12 bg-muted/30">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">How It Works</h2>
        <div className="space-y-6 max-w-3xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative pl-8">
              <div className="absolute left-0 top-1.5 w-4 h-4 bg-primary rounded-full" />
              {index < steps.length - 1 && (
                <div className="absolute left-2 top-7 w-[1px] h-full bg-primary/20" />
              )}
              <h3 className="font-semibold text-lg mb-2">{step.title}</h3>
              <p className="text-muted-foreground">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export type { ServiceProcessProps, ProcessStep };
